import { connect } from 'react-redux';
import AddRoles from './AddRoles';
import { createRoles } from '../../../redux/actions/roles';

const mapDispatchToProps = (dispatch) => ({
  createRoles: (roles) => dispatch(createRoles(roles)),
});

export default connect(undefined, mapDispatchToProps)(AddRoles);
